// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__aGjsM","wrapper_fullPage":"Loader_wrapper_fullPage__A+1Cf","container":"Loader_container__ToVPu","container_fullPage":"Loader_container_fullPage__lNRd6"};